module.exports = __webpack_public_path__ + "img/west-vvip-gal-4.354dcbc9.jpg";